import React, { useState, useEffect, useContext } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { Block, PaginationComponent, DataTable, BlockHead, BlockBetween, BlockHeadContent, BlockTitle, BlockDes } from "../../../components/Component";

import classnames from "classnames";
import { Nav, NavItem, NavLink, Row, Col, TabContent, TabPane, Button, ButtonGroup } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import StorePOListing from './StorePOListing';

const StorePOTabs = () => {
	const [onSearch, setonSearch] = useState(true);
	const [isOpen, setIsOpen] = useState(false);
	
	const toggle = () => {
		setIsOpen(!isOpen);
		setonSearch(!onSearch);
	};




	const [activeTab, setActiveTab] = useState("pending");
	const [approvalType, setApprovalType] = useState('catalogue');	
	const toggleTab = (tabName) => {		
		if (activeTab !== tabName) setActiveTab(tabName);
	};


	return (
		<React.Fragment>
			<Head title="Approval-listing"></Head>
			<Content>


				<BlockHead size="sm" data-test="ListPageHead">
					<BlockBetween>
						<BlockHeadContent>
							<BlockTitle tag="h3" page>
                            Store PO Listing
							</BlockTitle>
							<BlockDes className="text-soft">								
							</BlockDes>
						</BlockHeadContent>
					</BlockBetween>
				</BlockHead>			
				<div>		

                    <Nav tabs className="mt-n3">
                        <NavItem>
                            <NavLink
                                tag="a"
                                href="#tab"
                                className={classnames({ active: activeTab === "pending" })}
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    toggleTab('pending');
                                }}
                            >
                                Pending For Invoice Generation
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                tag="a"
                                href="#tab"
                                className={classnames({ active: activeTab === "all" })}
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    toggleTab('all');
                                }}
                            >
                                All
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="pending">								
                        {/* style={{margin: '-24px'}} */}
                            {activeTab === "pending" && <StorePOListing tabId="pending" /> }                            
                        </TabPane>
                        <TabPane tabId="all">								
                            {activeTab === "all" && <StorePOListing tabId="all" /> }                            
                        </TabPane>                        
                    </TabContent>
				
				</div>
			</Content>
			<ToastContainer />
		</React.Fragment>
	);
};

export default StorePOTabs;
